<div
  class="main-item-container"
  [class.not-clickable]="!item.respondentId"
  [attr.tabindex]="item.respondentId ? 0 : null"
  [attr.role]="item.respondentId ? 'button' : null"
  fxLayout="row"
  fxLayoutAlign="space-between center"
  (click)="onItemClicked(item)"
  (keydown)="onItemKeydown($event, item)"
>
  <div fxFlex fxLayout="column" class="details">
    <span class="entity-name" [matTooltip]="item.respondentFullName">{{
      item.respondentFullName
    }}</span>
    <span class="form-name" [matTooltip]="item.formName">{{
      item.formName
    }}</span>
  </div>

  <div fxFlex="none" fxLayout="column" fxLayoutAlign="center end">
    <span class="status">{{ item.formStatus }}</span>
    <span class="submitted-on">{{ item.submissionDate | dateDifference }}</span>
  </div>
</div>
